import React, { useEffect, useState } from 'react';
import { VistaprintAuth } from '@vp/auth-react';
import { authUtil } from 'src/utils/authUtil';
import { text } from 'src/utils/localizationUtil';

interface WebAuth {
  isSignedIn: () => boolean;
  getCanonicalId: () => string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getProfile: () => Record<string, any>;
  getToken: () => string;
  signIn: () => void;
  signOut: () => void;
}

export interface AuthContext {
  vpAuth: WebAuth | null;
}

export const AuthContext = React.createContext({} as AuthContext);

type Props = {
  children: React.ReactNode;
  isAgent?: boolean;
  culture?: string;
  blockUntilAuthenticated?: boolean;
  LoadingComponent?: React.ReactNode;
};

export const AuthContextProvider: React.FC<Props> = ({
  children,
  isAgent = false,
  blockUntilAuthenticated = false,
  LoadingComponent,
  culture,
}: Props) => {
  const [vpAuth, setAuth] = useState(null as WebAuth | null);

  useEffect(() => {
    authUtil.initialize(isAgent, culture).then(() => setAuth(new VistaprintAuth.WebAuth()));
  }, [setAuth, isAgent, culture]);

  if (blockUntilAuthenticated === true && vpAuth == null) {
    return LoadingComponent != null ? <>{LoadingComponent}</> : <div>{text('loading')}...</div>;
  }

  return <AuthContext.Provider value={{ vpAuth }}>{children}</AuthContext.Provider>;
};
